import { IconButton as ChakraUiIconButton } from '@chakra-ui/react';
import type { FC } from 'react';

import type { IconButtonProps } from './types';

const IconButton: FC<IconButtonProps> = ({
  dimension = 40,
  variant = 'ghost',
  ...props
}) => {
  const unit = `${dimension}px`;
  return (
    <ChakraUiIconButton
      width={unit}
      height={unit}
      minWidth={unit}
      borderRadius={unit}
      variant={variant}
      {...props}
    />
  );
};

export default IconButton;
